export default __webpack_public_path__ + "static/media/money-back@2x.bf135875.png";